import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';

import { PageDetailContent } from '@client/toolkit';

// import { PortfolioFinancialsCard } from '../../../components/portfolio-financials-card/portfolio-financials-card.component';
// import { BudgetCard } from '../../../components/budget-card/budget-card.component';
import { FinancialReportCard } from '../../../components/financial-report-card/financial-report-card.component';

export function BuildingPortfolioTabRoute() {
  const { buildingId } = useParams<{ buildingId: string }>();

  return (
    <PageDetailContent align="left">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          opacity: { ease: 'linear', duration: 0.2 },
          y: { ease: 'easeInOut', duration: 0.4 },
        }}
        className="space-y-2"
      >
        <FinancialReportCard buildingId={buildingId} />
        {/* <BudgetCard buildingId={buildingId} /> */}
        {/* <PortfolioFinancialsCard buildingId={buildingId} /> */}
      </motion.div>
    </PageDetailContent>
  );
}
